
// 白名单页面无需登录，无需权限
export const WHITE_LIST = [
  {
    name: '登录',
    path: '/login',
  }, {
    name: '404错误',
    path: '/404',
  }, {
    name: '大屏查看',
    path: '/screen/view',
  },
]

// 是否是白名单页面。
export function isWhiteList (to) {
  return WHITE_LIST.filter(i => to.path.includes(i.path)).length
}
